import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineChemTestsSchema: CollectionCreateSchema = {
  name: CollectionName.WineChemTests,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "assayNumber",
      type: "int32",
    },
    {
      name: "decimalPlaces",
      type: "int32",
    },
  ],
  visibility: CollectionVisibility.EC,
}
